import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useCurrencyLabel } from '@app/feature/invoice/hooks/use-currency-label.hook';
import { useInvoiceContext } from '@app/feature/invoice/invoice.context';

export const TotalCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const invoice = useInvoiceContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  const currencyLabel = useCurrencyLabel(invoice.currency);

  return (
    <Card
      gap={GapEnum.M}
      direction="row"
      justifyContent="space-between"
      alignItems="center">
      <AccentTitle
        as={HeadingEnum.H2}
        icon="currency-euro-circle"
        text={t('delmonicos-shared-sdk.outputs-invoice.total-ttc')}
        variant={AccentVariantEnum.Accent2}
      />
      <Text bold>
        {invoice.totalTTC} {currencyLabel}
      </Text>
    </Card>
  );
};
